import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue';
import { ProductService } from '@/services';
import SapVariantViewModel = Vertica.LouisPoulsen.Application.Commerce.ViewModels.SapVariantViewModel;
import TrackingService from '@/core/tracking.service';
import { store } from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'PriceInformationB2BAuthenticated',
  props: {
    productId: null,
    addToBasketCode: { default: '' },
    showAddToBasketB2BButton: { type: Boolean, default: false },
    allowQuote: { type: Boolean, default: false },
    product: { default: null },
    variant: { default: null },
    quoteToggle: { type: Boolean, default: false },
    allowsCordCutting: { type: Boolean, default: false }
  },
  emits: ["showModal"],
  setup(__props: any, { emit }: { emit: ({(e: 'showModal', value: boolean): void}), expose: any, slots: any, attrs: any }) {

const props = __props as { productId: string, addToBasketCode: string, showAddToBasketB2BButton: boolean, allowQuote: boolean, product: ProductBaseViewModel<VariantBaseViewObject> | null, variant: ProfessionalVariantViewObject | null, quoteToggle: boolean, allowsCordCutting: boolean }




const showStock = computed<boolean>(() => store.getters['app/showStock']);
const gaTrackingGoal = computed<string>(() => store.getters['catalog/gaTrackingGoal']);
const hideB2BPrices = computed<boolean>(() => store.getters['hideb2bprices/hideB2BPrices']);

const sapInfo = ref<SapVariantViewModel>(null);
const loadingSapInfo = ref<boolean>(true);

onMounted(getSapInfo);

function closeOverlay() {
    emit('showModal', false);
}

function getSapInfo(): void {
    ProductService.getSapVariant(props.productId).then((info) => {
        sapInfo.value = info;
        loadingSapInfo.value = false;
    }).catch(() => {
        loadingSapInfo.value = false;
    });

    TrackingService.event('Ecommerce', gaTrackingGoal.value, 'Price info - variant selector');
}


return { __sfc: true,props, emit, showStock, gaTrackingGoal, hideB2BPrices, sapInfo, loadingSapInfo, closeOverlay, getSapInfo }
}

})